import axios from 'axios'

function dealWithResult (data, resolve, reject, httpCode) {
  if (data.data.code && (!httpCode && (parseInt(data.data.code) === 100) || (httpCode && (parseInt(data.data.code) === 200)))) {
    if (!httpCode) {
      resolve(data.data.data)
    } else if (data.data.success) {
      resolve(data.data.success)
    } else {
      resolve(data.data.data)
    }
  } else {
    // TODO special code
    // window.$router.replace
    if (!httpCode && (parseInt(data.data.code) === 403 || parseInt(data.data.code) === 401)) {
      $router.replace('/login')
    }
    if (httpCode && parseInt(data.data.code) === 401) {
      $router.replace('/login')
    }
    if (!httpCode) {
      if (data.data.code === '406') {
        reject(data.data)
      } else {
        reject(data.data.message)
      }
    } else {
      reject(data.data.error)
    }
  }
}

function dealWithError (data, resolve, reject) {
  reject(data.message)
}

function post (url, body, token, param, httpCode) {
  return new Promise(function (resolve, reject) {
    axios.post(url, body, {
      params: param,
      headers: {
        'token': (!token ? '' : token),
        'locale': 'zh_CN'
      }
    }).then((response) => {
      dealWithResult(response, resolve, reject, httpCode)
      // resolve()
    }, (response) => {
      dealWithError(response, resolve, reject)
      // reject()
    })
  })
}

function put (url, body, token, params, httpCode) {
  return new Promise(function (resolve, reject) {
    axios.put(url, body, {
      params,
      headers: {
        'token': (!token ? '' : token),
        'locale': 'zh_CN'
      }
    }).then((response) => {
      dealWithResult(response, resolve, reject, httpCode)
      // resolve()
    }, (response) => {
      dealWithError(response, resolve, reject)
      // reject()
    })
  })
}

function get (url, param, token, httpCode) {
  return new Promise(function (resolve, reject) {
    axios.get(url, {
      params: param,
      headers: {
        'token': (!token ? '' : token),
        'locale': 'zh_CN'
      }
    }).then((response) => {
      dealWithResult(response, resolve, reject, httpCode)
    }, (response) => {
      dealWithError(response, resolve, reject)
    })
  })
}

function deleted (url, token, param, httpCode) {
  return new Promise(function (resolve, reject) {
    axios.delete(url, {
      params: param,
      headers: {
        'token': (!token ? '' : token),
        'locale': 'zh_CN'
      }
    }).then((response) => {
      dealWithResult(response, resolve, reject, httpCode)
      // resolve()
    }, (response) => {
      dealWithError(response, resolve, reject)
      // reject()
    })
  })
}

export default {
  // IMG_URL: 'https://img.zhihuishitang.net/',
  IMG_URL: 'https://img.qzhlkj.net/',
  // code 200 success
  groupByDepartmentStatics (userInfo, param) {
    let query = {
      token: userInfo.token,
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get('/ods/v1/statements/hall/dining/groupByDepartment', query, userInfo.token, true)
  },
  groupBydiningOperators (userInfo, param) {
    let query = {
      token: userInfo.token,
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get(`/ods/v1/statements/hall/income/detail/groupByDiningOperators`, query, userInfo.token, true)
  },
  groupByDepartmentDetail (userInfo, param) {
    let query = {
      token: userInfo.token,
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get('/ods/v1/statements/hall/dining/detail/groupByDepartment', query, userInfo.token, true)
  },
  commentsGroupByDay (userInfo, param) {
    let query = {
      token: userInfo.token,
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get('/ods/v1/statements/hall/score/groupByDay', query, userInfo.token, true)
  },
  getDinincount (userInfo, param) {
    let query = {
      token: userInfo.token,
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get(`/ods/v1/statements/hall/dining/groupByDay`, query, userInfo.token, true)
  },
  // code 100 success
  patientOrderStat (userInfo, param) {
    return get(`/v2/manage/companies/${userInfo.companyId}/patientOrderStat`, param, userInfo.token)
  },
  patientBeds (userInfo, param) {
    return get(`/v2/manage/companies/${userInfo.companyId}/patientBeds`, param, userInfo.token)
  },
  issueCard (userInfo, param) {
    return get(`/v2/manage/companies/${userInfo.companyId}/issueCard/records`, param, userInfo.token)
  },
  userOfflineWithdrawalLog (userInfo, param) {
    return get(`/v3/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/userOfflineWithdrawalLog`, param, userInfo.token)
  },
  userOfflineWithdrawalSetting (userInfo, param) {
    return get(`/v3/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/userOfflineWithdrawalSetting`, param, userInfo.token)
  },
  saveuserOfflineWithdrawalSetting (userInfo, data) {
    return post(`/v3/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/userOfflineWithdrawalSetting`, data, userInfo.token)
  },
  forcedRefreshPatientBeds (userInfo) {
    return post(`/v2/manage/companies/${userInfo.companyId}/syncPatientInfo?managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  recharge (userInfo, param, userId) {
    return post(`v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}/recharge`, param, userInfo.token)
  },
  faceCreate (userInfo, param) {
    return post(`/v3/face/create`, param, userInfo.token)
  },
  faceUpdate (userInfo, param) {
    return post(`/v3/face/update`, param, userInfo.token)
  },
  fingerPrints (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${param.ingerprintId}/fingerPrints
    `, param, userInfo.token)
  },
  orderStatement (userInfo, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/orderStatement`, param, userInfo.token)
  },
  rechargeStatement (userInfo, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/rechargeStatement`, param, userInfo.token)
  },
  dailyRechargeStatement (userInfo, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/dailyRechargeStatement`, param, userInfo.token)
  },
  userCardNo (userInfo, param) {
    return post(`v2/manage/company/${userInfo.companyId}/import/userCardNo`, param, userInfo.token, {
      managerId: userInfo.managerId
    })
  },
  unConsumedUserReport (userInfo, param) {
    let query = {
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get('/report/report/unConsumedUserReport', query, userInfo.token)
  },
  unConsumedItemReport (userInfo, param) {
    let query = {
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get('/report/report/unConsumedItemReport', query, userInfo.token)
  },
  consumeTime (userInfo, param) {
    let query = {
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get('/v3/manage/periods/orders/consumetime', query, userInfo.token)
  },
  periodBatchItemReport (userInfo, param) {
    let query = {
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get('/report/report/periodBatchItemReport', query, userInfo.token)
  },
  itemComments (userInfo, param, hallId) {
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/itemComments`, param, userInfo.token)
  },
  itemCommentStatics (userInfo, param, hallId) {
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/itemCommentStatistic`, param, userInfo.token)
  },

  activateAccount (context, param, hallId) {
    return post(context, '/activateAccount', param)
  },
  login (info) {
    return post('/v1/company/login', info)
  },
  logout (userInfo) {
    return get(`/v1/company/logout`, { managerId: userInfo.managerId }, userInfo.token)
  },
  getPeriods (context, userInfo) {
    return get(context, '/period', {
      token: userInfo.token,
      userId: userInfo.userId,
      companyId: userInfo.companyId
    })
  },
  getHomePage (context, userInfo) {
    return get(context, '/getHomePage', {
      token: userInfo.token,
      userId: userInfo.userId,
      companyId: userInfo.companyId
    })
  },
  queryHalls (userInfo) {
    return get('/v1/manage/hall/queryHalls', {
      userId: userInfo.managerId,
      companyId: userInfo.companyId
    }, userInfo.token)
  },
  modifyHall (userInfo, hallId, hallInfo) {
    return post(`/v1/manage/hall/company/${userInfo.companyId}/user/${userInfo.managerId}/hallId/${hallId}/halls`, hallInfo, userInfo.token)
  },
  queryCookingListAll (userInfo, param) { // 烧制清单-总单
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/orderItemStatement`, param, userInfo.token)
  },
  queryCookingListSub (userInfo, param) { // 烧制清单-分单
    return get(`/v2/manage/company/${userInfo.companyId}/orders/itemStatement?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  queryCookingListSubV3 (userInfo, param) { // 烧制清单-分单
    let query = {
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get(`/v3/manage/company/${userInfo.companyId}/orders/itemStatement`, query, userInfo.token)
  },
  queryCookingListSubV3New (userInfo, param) { // 烧制清单-分单
    let query = {
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    }
    Object.assign(query, param)
    return get(`/v3/manage/company/${userInfo.companyId}/orders/newItemStatement`, query, userInfo.token)
  },
  queryPurchaseList (userInfo, hallId, param) { // 采购清单
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/materialReport`, param, userInfo.token)
  },
  // 基础菜品库
  queryCategories (userInfo, hallId) { // 查询基础类目
    return get('/v1/manage/food/queryCategories', {
      userId: userInfo.managerId,
      companyId: userInfo.companyId,
      hallId: hallId
    }, userInfo.token)
  },
  addCategories (userInfo, param) {
    return put(`/v1/manage/food/company/${userInfo.companyId}/user/${userInfo.managerId}/categories`, param, userInfo.token)
  },
  batchSendOrderNotConsumeRemind (userInfo, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/batchSendOrderNotConsumeRemind`, param, userInfo.token)
  },
  batchConsumeOrders (userInfo, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/batchConsumeOrders`, param, userInfo.token)
  },
  batchConsumeOrdersRollback (userInfo, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/batchConsumeOrdersRollback`, param, userInfo.token)
  },
  editCategories (userInfo, cateId, param) {
    return post(`/v1/manage/food/company/${userInfo.companyId}/user/${userInfo.managerId}/cateId/${cateId}/categories`, param, userInfo.token)
  },
  copyDishItems (userInfo, hallId, param) {
    return post(`/v2/manage/food/company/${userInfo.companyId}/hall/${hallId}/copyItems`, param, userInfo.token)
  },
  deleteCategories (userInfo, cateId) {
    return deleted(`/v1/manage/food/company/${userInfo.companyId}/user/${userInfo.managerId}/cateId/${cateId}/categories`, userInfo.token)
  },
  queryBaseDishes (userInfo, param) {
    return get('/v1/manage/food/queryItems', param, userInfo.token)
  },
  deleteBaseDish (userInfo, hallId, itemId) {
    return post(`/v2/manage/food/company/${userInfo.companyId}/hall/${hallId}/delItems`, {
      managerId: userInfo.managerId,
      itemIds: [itemId]
    }, userInfo.token)
  },
  queryCateUnusedItemNo (userInfo, cateId) {
    return get('/v1/manage/food/queryCateUnusedItemNo', {
      companyId: userInfo.companyId,
      managerId: userInfo.managerId,
      cateId: cateId
    }, userInfo.token)
  },
  addBaseDish (userInfo, param) { // 新增基础菜品
    return put(`/v1/manage/food/company/${userInfo.companyId}/user/${userInfo.managerId}/items`, param, userInfo.token)
  },
  modifyBaseDish (userInfo, itemId, param) { //  修改基础菜品
    return post(`/v1/manage/food/company/${userInfo.companyId}/user/${userInfo.managerId}/itemId/${itemId}/items`, param, userInfo.token)
  },
  queryMaterialCates (userInfo, hallId) { //  查询成本卡材料类目
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/materialCates`, {}, userInfo.token)
  },
  queryMaterials (userInfo, hallId, param) { //  查询成本卡材料列表
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/materials`, param, userInfo.token)
  },
  queryMaterials2 (userInfo, param) { //  查询成本卡材料列表
    return get(`/v3/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/materials`, param, userInfo.token)
  },
  addMaterial (userInfo, hallId, param) { // 新增材料
    return post(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/material`, param, userInfo.token)
  },
  // 基础菜品库 (over)
  queryMenuTemplate (userInfo, hallId) { //  查询模板排菜
    return get(`/v2/manage/company/${userInfo.companyId}/hall/${hallId}/dining/menuTemplateDetails`, {
      managerId: userInfo.managerId
    }, userInfo.token)
  },
  updateMenuTemplage (userInfo, hallId, param) { // 更新模板排菜
    return post(`/v2/manage/company/${userInfo.companyId}/hall/${hallId}/dining/menuTemplateDetails?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  addWaiter (userInfo, param) {
    return post(`/v2/company/${userInfo.companyId}/manager/${userInfo.managerId}/waiter`, param, userInfo.token)
  },
  modifyWaiter (userInfo, param, waiterId) {
    return put(`/v2/company/${userInfo.companyId}/manager/${userInfo.managerId}/waiter/${waiterId}`, param, userInfo.token)
  },
  deleteWaiter (userInfo, waiterId) {
    return deleted(`/v2/company/${userInfo.companyId}/manager/${userInfo.managerId}/waiter/${waiterId}`, userInfo.token)
  },
  queryWaiter (userInfo) { // 查询点餐员(阿姨)
    return get(`/v2/company/${userInfo.companyId}/manager/${userInfo.managerId}/waiter`, {}, userInfo.token)
  },
  queryWaiterStatics (userInfo, param) { // 查询点餐员对账报表
    return get(`/v2/manage/waiter/order/statement?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  queryOdsOperator (userInfo) { // 查询 ods操作员
    return get(`/ods/v1/companies/${userInfo.companyId}/diningOperator?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}&token=${userInfo.token}&diningHallIdStr=null`, {}, userInfo.token, true)
  },
  queryOperatorStatics (userInfo, param) { // 查询操作员对账报表
    return get(`/ods/v1/statements/hall/income/detail/groupByDepartment?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}&token=${userInfo.token}`, param, undefined, true)
  },
  queryOnAccountStatics (userInfo, param) { // 查询挂账对账报表
    return get(`/v2/manage/order/distribution?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  queryDistributionOrderStatics (userInfo, param) { // 查询配送/未配送订单统计
    return get(`/v2/manage/order/distribution/statement?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  queryDistributionOrders (userInfo, param) { // 查询配送/未配送订单详情
    return get(`/v2/manage/order/distribution?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  queryWaiterDeliverArrangement (userInfo) { // 查询点餐员对应的地址
    return get(`/v3/company/waiterDeliverArrangement?companyId=${userInfo.companyId}`, {}, userInfo.token)
  },
  queryDistributionDishes (userInfo, param) { // 查询需要配送的菜
    return get(`/v2/manage/order/distribution/item?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  distributionOrder (userInfo, param) { // 配送订单
    return post(`/v2/manage/order/distribution?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  queryPeriodNames (userInfo) {
    return get('/v1/manage/period/queryPeriodNames', {
      userId: userInfo.managerId,
      companyId: userInfo.companyId
    }, userInfo.token)
  },
  addPeriodName (userInfo, info) {
    return put(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periodNames`, info, userInfo.token)
  },
  modifyPeriodName (userInfo, nameId, info) {
    return post(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periodNameId/${nameId}/periodNames`, info, userInfo.token)
  },
  deletePeriodName (userInfo, nameId) {
    return deleted(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periodNameId/${nameId}/periodNames`, userInfo.token)
  },
  addHall (userInfo, requestDic) {
    return put(`/v1/manage/hall/company/${userInfo.companyId}/user/${userInfo.managerId}/halls`, requestDic, userInfo.token)
  },
  deleteHall (userInfo, hallId) {
    return deleted(`/v1/manage/hall/company/${userInfo.companyId}/user/${userInfo.managerId}/hallId/${hallId}/halls`, userInfo.token)
  },
  deleteDepartment (userInfo, departmentId) {
    return deleted(`/v1/company/manager/${userInfo.managerId}/department/${departmentId}`, userInfo.token)
  },
  queryDepartment (userInfo) {
    return get(`/v1/company/manager/${userInfo.managerId}/department`, {}, userInfo.token)
  },
  queryOperator (userInfo) {
    return get(`/v2/cashier/company/${userInfo.companyId}/hall/0/admin/operator`, {}, userInfo.token)
  },
  addDepartment (userInfo, requestDic) {
    return post(`/v1/company/manager/${userInfo.managerId}/department`, requestDic, userInfo.token)
  },
  modifyPassword (data) {
    return post(`/v1/company/modifyPassword`, data, null)
  },
  modifyDepartment (userInfo, departmentId, requestDic) {
    return put(`/v1/company/manager/${userInfo.managerId}/department/${departmentId}`, requestDic, userInfo.token)
  },
  queryOrders (userInfo, pageNo, param) {
    return get(`/report/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/orders?pageNo=${pageNo}`, param, userInfo.token)
  },
  checkABCRecharge (userInfo, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/checkABCRecharge`, param, userInfo.token)
  },
  abcRechargeFailedCheck (userInfo, param) {
    return get(`/v3/manage/companySetting/abcRechargeFailedCheck`, param, userInfo.token)
  },
  exportOrder (userInfo, data, param) {
    return post(`/v1/manager/exportTask/exportOrder`, data, userInfo.token, {
      ...param,
      pageNo: 1,
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    })
  },
  setAbcRechargeFailedCheck (userInfo, data) {
    return post(`/v3/manage/companySetting/abcRechargeFailedCheck`, data, userInfo.token, {
      managerId: userInfo.managerId,
      companyId: userInfo.companyId
    })
  },
  queryHallPeriods (userInfo, hallId) {
    return get('/v1/manage/period/queryPeriods', {
      userId: userInfo.managerId,
      companyId: userInfo.companyId,
      hallId: hallId
    }, userInfo.token)
  },
  addHallPeriods (userInfo, periodInfo) {
    return put(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periods`, periodInfo, userInfo.token)
  },
  modifyHallPeriods (userInfo, periodInfo, periodId) {
    return post(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periodId/${periodId}/periods`, periodInfo, userInfo.token)
  },
  deleteHallPeriods (userInfo, periodId) {
    return deleted(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periodId/${periodId}/periods`, userInfo.token)
  },
  getDistributionInfo (userInfo, hallId) {
    return get(`/v1/manage/companies/${userInfo.companyId}/halls/${hallId}/distributionInfo`, {
      managerId: userInfo.managerId
    }, userInfo.token)
  },
  addDistributionInfo (userInfo, info, hallId) {
    return post(`/v1/manage/companies/${userInfo.companyId}/halls/${hallId}/distributionInfo`, info, userInfo.token, {
      managerId: userInfo.managerId
    })
  },
  deleteDistributionInfo (userInfo, hallId, distributionId) {
    return deleted(`/v1/manage/companies/${userInfo.companyId}/halls/${hallId}/distributionInfo/${distributionId}`, userInfo.token, {
      managerId: userInfo.managerId
    })
  },
  getPickupInfo (userInfo, hallId) {
    return get(`/v1/manage/companies/${userInfo.companyId}/halls/${hallId}/pickupInfo`, {
      managerId: userInfo.managerId
    }, userInfo.token)
  },
  addPickupInfo (userInfo, hallId, pickupInfo) {
    return post(`/v1/manage/companies/${userInfo.companyId}/halls/${hallId}/pickupInfo`, pickupInfo, userInfo.token, {
      managerId: userInfo.managerId
    })
  },
  deletePickupInfo (userInfo, hallId, pickupId) {
    return deleted(`/v1/manage/companies/${userInfo.companyId}/halls/${hallId}/pickupInfo/${pickupId}`, userInfo.token, {
      managerId: userInfo.managerId
    })
  },
  queryOrderDetail (userInfo, orderId) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/orders/${orderId}/orderItems`, {}, userInfo.token)
  },
  chongzhengOrder (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/chongzhengOrder`, param, userInfo.token)
  },
  cancelOrders (userInfo, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/orders/${param.orderIds}`, null, userInfo.token)
  },
  queryPositions (userInfo) {
    return get(`/v1/company/manager/${userInfo.managerId}/position`, {}, userInfo.token)
  },
  addPosition (userInfo, param) {
    return post(`/v1/company/manager/${userInfo.managerId}/position`, param, userInfo.token)
  },
  modifyPosition (userInfo, positionId, param) {
    return put(`/v1/company/manager/${userInfo.managerId}/position/${positionId}`, param, userInfo.token)
  },
  deletePosition (userInfo, positionId) {
    return deleted(`/v1/company/manager/${userInfo.managerId}/position/${positionId}`, userInfo.token)
  },
  queryUser (userInfo, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/userquery`, param, userInfo.token)
  },
  resetPassword (userInfo, userId, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}/password`, param, userInfo.token)
  },
  queryTags (userInfo, diningHallId) {
    return get(`/v2/company/manager/${userInfo.managerId}/hall/tag?diningHallId=${diningHallId}`, {}, userInfo.token)
  },
  addTag (userInfo, param) {
    return post(`/v2/company/manager/${userInfo.managerId}/hall/tag`, param, userInfo.token)
  },
  modifyTag (userInfo, tagId, param) {
    return put(`/v2/company/manager/${userInfo.managerId}/hall/tag/${tagId}`, param, userInfo.token)
  },
  deleteTag (userInfo, tagId) {
    return deleted(`/v2/company/manager/${userInfo.managerId}/hall/tag/${tagId}`, userInfo.token)
  },
  queryEmployee (userInfo, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user`, param, userInfo.token)
  },
  batchRecharge (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/batchRecharge`, param, userInfo.token)
  },
  daochu (userInfo, param) {
    return post(`/ncp_healthy/daochu`, {}, userInfo.token, param)
  },
  getIndexData (userInfo, param) {
    return post(`/ncp_healthy`, {}, userInfo.token, param)
  },
  batchOrders (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/batchOrders`, param, userInfo.token)
  },
  batchUserGroup (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/batchUserGroup`, param, userInfo.token)
  },
  batchUserStatus (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/batchUserStatus`, param, userInfo.token)
  },
  batchDepartment (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/batchDepartment`, param, userInfo.token)
  },
  batchUserTemp (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/batchUserTemp`, param, userInfo.token)
  },
  deleteEmployee (userInfo, userId) {
    return deleted(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}`, userInfo.token)
  },
  deleteFace (userInfo, param) {
    return post(`/v3/face/delete`, param, userInfo.token)
  },
  deleteByUserId (userInfo, param) {
    return get(`/v3/face/deleteByUserId`, param, userInfo.token)
  },
  disableUser (userInfo, userId) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}/disable`, {}, userInfo.token)
  },
  enableUser (userInfo, userId) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}/enable`, {}, userInfo.token)
  },
  addEmployee (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user`, param, userInfo.token)
  },
  modifyEmployee (userInfo, param, userId) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}&userId=${userId}`, param, userInfo.token)
  },
  getEmployee (userInfo, userId) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}`, {}, userInfo.token)
  },
  queryHallOP (userInfo) {
    return get(`/v2/company/${userInfo.companyId}/manager/${userInfo.managerId}/hall/operator`, {}, userInfo.token)
  },
  deleteHallOP (userInfo, diningOperatorId) {
    return deleted(`/v2/company/${userInfo.companyId}/manager/${userInfo.managerId}/hall/operator/${diningOperatorId}`, userInfo.token)
  },
  addHallOP (userInfo, param) {
    return post(`/v2/company/${userInfo.companyId}/manager/${userInfo.managerId}/hall/operator`, param, userInfo.token)
  },
  modifyHallOP (userInfo, operatorId, param) {
    return put(`/v2/company/${userInfo.companyId}/manager/${userInfo.managerId}/hall/operator/${operatorId}`, param, userInfo.token)
  },
  queryManager (userInfo) {
    return get(`/v2/company/manager/${userInfo.managerId}/manager`, {}, userInfo.token)
  },
  addManager (userInfo, param) {
    return post(`/v2/company/manager/${userInfo.managerId}/manager`, param, userInfo.token)
  },
  deleteManager (userInfo, managerId) {
    return deleted(`/v1/company/manager/${userInfo.managerId}/manager/${managerId}`, userInfo.token)
  },
  modifyNanager (userInfo, managerId, param) {
    return put(`/v2/company/manager/${userInfo.managerId}/manager/${managerId}`, param, userInfo.token)
  },
  modifyPwd (userInfo, param) {
    return post(`/v1/company/updatePassword`, param, userInfo.token)
  },
  queryAddressRule (userInfo) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/addressRule`, {}, userInfo.token)
  },
  detailAddressRule (userInfo, addressRuleId) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/addressRule/${addressRuleId}/addressRuleDetail`, {}, userInfo.token)
  },
  queryAddress (userInfo) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/address`, {}, userInfo.token)
  },
  addAddressRule (userInfo, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/addressRule`, param, userInfo.token)
  },
  modifyAddressRule (userInfo, addressRuleId, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/addressRule/${addressRuleId}`, param, userInfo.token)
  },
  deleteAddressRule (userInfo, addressRuleId) {
    return deleted(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/addressRule/${addressRuleId}`, userInfo.token)
  },
  addweDetail (userInfo, addressRuleId, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/addressRule/${addressRuleId}/addressRuleDetail`, param, userInfo.token)
  },
  deleteAddressRuleDetail (userInfo, addressRuleId, addressRuleDetailId) {
    return deleted(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/addressRule/${addressRuleId}/addressRuleDetail/${addressRuleDetailId}`, userInfo.token)
  },
  modifyAddressRuleDetail (userInfo, addressRuleId, addressRuleDetailId, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/addressRule/${addressRuleId}/addressRuleDetail/${addressRuleDetailId}`, param, userInfo.token)
  },
  queryDiningBatches (userInfo, hallId, periodId) {
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/diningBatches`, {
      periodId: periodId
    }, userInfo.token)
  },
  deleteDiningBatches (userInfo, hallId, diningBatchId) {
    return deleted(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/diningBatch/${diningBatchId}`, userInfo.token)
  },
  diningBatches (userInfo, hallId, periodId) {
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/diningBatches?periodId=${periodId}`, {}, userInfo.token)
  },
  userDiningBatches (userInfo, hallId, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/userDiningBatches`, param, userInfo.token)
  },
  searchUserDiningBatches (userInfo, hallId, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/userDiningBatches`, param, userInfo.token)
  },
  addDiningBatch (userInfo, hallId, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/diningBatch`, param, userInfo.token)
  },
  queryUserDiningBatches (userInfo, hallId, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/userDiningBatches`, param, userInfo.token)
  },
  modifyDiningBatch (userInfo, hallId, diningBatchId, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/diningBatch/${diningBatchId}`, param, userInfo.token)
  },
  deleteUserDiningBatch (userInfo, hallId, param) {
    return deleted(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/userDiningBatches`, userInfo.token, param)
  },
  diningBatchDetail (userInfo, hallId, diningBatchId, pageSize, pageNo) {
    return get(`/v1/manage/company/${userInfo.companyId}/hall/${hallId}/manager/${userInfo.managerId}/diningBatch/${diningBatchId}/users?pageSize=${pageSize}&pageNo=${pageNo}`, {}, userInfo.token)
  },
  queryPeriodsPlans (userInfo, param) {
    return get(`/v1/manage/period/queryPeriodPlans`, param, userInfo.token)
  },
  addQueryPeriodsPlan (userInfo, param) {
    return put(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periodPlans`, param, userInfo.token)
  },
  queryPeriodMenu (userInfo, param) {
    return get(`/v1/manage/period/queryPeriodMenu`, param, userInfo.token)
  },
  delMenuItemsAndMeals (userInfo, hallId, param) {
    return post(`/v2/manage/period/company/${userInfo.companyId}/hall/${hallId}/delMenuItemsAndMeals`, param, userInfo.token)
  },
  copyMenuItems (userInfo, hallId, planId, param) {
    return post(`/v2/manage/food/company/${userInfo.companyId}/hall/${hallId}/plan/${planId}/copyMenuItems`, param, userInfo.token)
  },
  modifyPeriodMenu (userInfo, periodMenuId, param) {
    return post(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periodMenuId/${periodMenuId}/periodMenu`, param, userInfo.token)
  },
  queryCondition (userInfo, hallId, cateId, queryCondition, itemKind) {
    return get(`/v1/manage/food/queryItems?userId=${userInfo.managerId}&companyId=${userInfo.companyId}&hallId=${hallId}&cateId=${cateId}&queryCondition=${queryCondition}&itemKind=${itemKind}`, {}, userInfo.token)
  },
  putPeriodMenu (userInfo, param, body) {
    return put(`/v3/companies/${userInfo.companyId}/periodMenus`, body, userInfo.token, param)
  },
  // putPeriodMenu (userInfo, param, body) {
  //   return put(`/v3/companies/${userInfo.companyId}/addPeriodMenus`, body, userInfo.token, param)
  // },
  getAllUser (userInfo, status, pageIndex, pageSize) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user`, {
      userCompanyStatus: status,
      pageSize: pageSize,
      pageIndex: pageIndex
    }, userInfo.token)
  },
  uploadSubsidy (userInfo, param) {
    return post(`/v2/manage/company/${userInfo.companyId}/import/userSubsidy`, param, userInfo.token, {
      managerId: userInfo.managerId
    })
  },
  changePeriodPlan (userInfo, periodPlanId, param) {
    return post(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periodPlanId/${periodPlanId}/periodPlans`, param, userInfo.token)
  },
  getWithdrawals (userInfo, hallId) {
    return get(`/v2/manager/company/${userInfo.companyId}/hall/${hallId}/withdrawals?managerId=${userInfo.managerId}&withdrawalStatus=0`, {}, userInfo.token)
  },
  payWithdrawals (userInfo, hallId) {
    return get(`/v2/manager/company/${userInfo.companyId}/hall/${hallId}/withdrawals?managerId=${userInfo.managerId}&withdrawalStatus=0`, {}, userInfo.token)
  },
  applyforWithdrawals (userInfo, hallId) {
    return put(`/v2/manager/company/${userInfo.companyId}/hall/${hallId}/withdrawals?managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  withdrawalLogs (userInfo, hallId) {
    return get(`/v2/manager/company/${userInfo.companyId}/hall/${hallId}/withdrawalLogs?managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  saveIssueCardSetting (userInfo, param) {
    return post(`/v1/manage/companies/${userInfo.companyId}/issueCard/settings?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  getIssueCardSetting (userInfo) {
    return get(`/v1/manage/companies/${userInfo.companyId}/issueCard/settings?managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  getHallStatics (userInfo, param) {
    return get(`/ods/v1/statements/hall/income/groupByDay`, param, userInfo.token, true)
  },
  groupByDepartment (userInfo, param) {
    return get(`/ods/v1/statements/hall/income/detail/groupByDepartment`, param, userInfo.token, true)
  },
  record (userInfo, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/batchOrders`, param, userInfo.token)
  },
  exportTransactionDetail (userInfo, param) {
    return post(`/v3/manager/exportTask/exportTransactionDetail?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}&beginTime=${param.beginTime}&endTime=${param.endTime}`, {}, userInfo.token)
  },
  exportDepartmentSubsidy (userInfo, param) {
    return post(`/v3/manager/exportTask/exportDepartmentSubsidy?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}&beginTime=${param.beginTime}&endTime=${param.endTime}`, {}, userInfo.token)
  },
  exportOperatorSummary (userInfo, param) {
    return post(`/v3/manager/exportTask/exportOperatorSummary?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}&beginTime=${param.beginTime}&endTime=${param.endTime}`, {}, userInfo.token)
  },
  exportTransactionDaySummary (userInfo, param) {
    return post(`/v3/manager/exportTask/exportTransactionDaySummary?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}&beginTime=${param.beginTime}&endTime=${param.endTime}`, {}, userInfo.token)
  },
  exportIncomeAndExpenditure (userInfo, param) {
    return post(`/v3/manager/exportTask/exportIncomeAndExpenditure?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}&beginTime=${param.beginTime}&endTime=${param.endTime}`, {}, userInfo.token)
  },
  exportABCRechargeTrace (userInfo, param) {
    return post(`/v3/manager/exportTask/exportABCRechargeTrace?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}&beginTime=${param.beginTime}&endTime=${param.endTime}`, {}, userInfo.token)
  },
  exportOverview (userInfo, param) {
    return post(`/v3/manager/exportTask/exportOverview?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}&beginTime=${param.beginTime}&endTime=${param.endTime}`, {}, userInfo.token)
  },
  exportTask (userInfo, param) {
    return get(`/v3/manager/exportTask/query?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  userNextSubsidy (userInfo, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/userNextSubsidy?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  queryManagers (userInfo) {
    return get(`/v2/manage/companies/${userInfo.companyId}/managers?managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  queryRecharges (userInfo, param) {
    return get(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/recharges`, param, userInfo.token)
  },
  queryMonthlyStatistical (userInfo, param) {
    return get(`/report/v3/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/userBalances`, param, userInfo.token)
  },
  queryFaceList (userInfo, param) {
    return get(`/v3/face/list`, param, userInfo.token)
  },
  queryMobilebankingpay (userInfo) {
    return get(`/v3/manage/paysetting/mobilebankingpay?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  mobilebankingpay (userInfo, param) {
    return post(`/v3/manage/paysetting/mobilebankingpay?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  modifyUserName (userInfo, userId, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}/userName`, param, userInfo.token)
  },
  startPeriodPlan (userInfo, periodPlanId, param) {
    return post(`/v1/manage/period/company/${userInfo.companyId}/user/${userInfo.managerId}/periodPlanId/${periodPlanId}/periodPlans`, param, userInfo.token)
  },
  queryDoctorAdvice (userInfo) {
    return get(`/v2/manage/companies/${userInfo.companyId}/patientDoctorAdviceChanges?pageNo=1&pageSize=10000&patientDoctorAdviceChangeStatus=1&managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  queryBedList (userInfo, param) {
    return get(`/v2/manage/companies/${userInfo.companyId}/patientDoctorAdvices`, param, userInfo.token)
  },
  readDoctorAdvice (userInfo, param) {
    return put(`/v2/manage/companies/${userInfo.companyId}/patientDoctorAdviceChanges?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  queryNameTempate (userInfo, hallId) {
    return get(`/v2/manage/companies/${userInfo.companyId}/hall/${hallId}/menuTemplates?managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  deleteNameTempate (userInfo, hallId, menuTemplateId) {
    return deleted(`/v2/manage/companies/${userInfo.companyId}/hall/${hallId}/menuTemplates/${menuTemplateId}?managerId=${userInfo.managerId}`, userInfo.token)
  },
  addNameTempate (userInfo, hallId, param) {
    return post(`/v2/manage/companies/${userInfo.companyId}/hall/${hallId}/menuTemplates?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  modifyNameTempate (userInfo, hallId, menuTemplateId, param) {
    return put(`/v2/manage/companies/${userInfo.companyId}/hall/${hallId}/menuTemplates/${menuTemplateId}?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  getNameTempateDetail (userInfo, hallId, menuTemplateId) {
    return get(`/v2/manage/companies/${userInfo.companyId}/hall/${hallId}/menuTemplates/${menuTemplateId}/details?managerId=${userInfo.managerId}`, {}, userInfo.token)
  },
  modifyNameTemplate (userInfo, hallId, menuTemplateId, param) {
    return put(`/v2/manage/companies/${userInfo.companyId}/hall/${hallId}/menuTemplates/${menuTemplateId}/details?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  // applyNameTemplate (userInfo, hallId, param) {
  //   return put(`/v2/manage/companies/${userInfo.companyId}/hall/${hallId}/menus/template?managerId=${userInfo.managerId}`, param, userInfo.token)
  // }
  applyNameTemplate (userInfo, hallId, param) {
    return put(`/v3/manage/menus/template`, param, userInfo.token, {
      managerId: userInfo.managerId,
      hallId,
      companyId: userInfo.companyId
    })
  },
  userInfoOperate (userInfo, param) {
    return post(`/v3/manage/import/userInfo`, param, userInfo.token, {
      managerId: userInfo.managerId,
      companyId: userInfo.companyId,
      createDepartment: param.createDepartment
    })
  },
  searchOrderEvaluate (userInfo, param) {
    return get(`/v3/manage/users/comments`, param, userInfo.token)
  },
  // 订单平均消费报表
  orderGroupByDay (userInfo, param) {
    let query = {
      managerId: userInfo.managerId,
      companyId: userInfo.companyId,
      token: userInfo.token
    }
    Object.assign(query, param)
    return get(`/ods/v1/statements/hall/order/groupByDay`, query, undefined, true)
  },
  searchOrderComment (userInfo, param) {
    return get(`/v3/manage/orders/comments`, param, userInfo.token)
  },
  makeupCar (userInfo, userId, param) {
    return post(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}/card`, param, userInfo.token)
  },
  changeCar (userInfo, userId, param) {
    return put(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}/card`, param, userInfo.token)
  },
  checkoutCar (userInfo, userId, backCardRefund) {
    return deleted(`/v1/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/user/${userId}/card?backCardRefund=${backCardRefund}`, userInfo.token)
  },
  getRechargeSettings (userInfo) {
    return get(`/v1/manage/companies/${userInfo.companyId}/recharge/settings`, {
      managerId: userInfo.managerId
    }, userInfo.token)
  },
  findConfigByCompanyId (userInfo) {
    return get(`/v3/config/findConfigByCompanyId`, {
      companyId: userInfo.companyId
    }, userInfo.token)
  },
  updateConfig (userInfo, params) {
    return post(`/v3/config/updateConfig`, params, userInfo.token, params)
  },
  rechargeSet (userInfo, params) {
    return post(`/v1/company/manager/${userInfo.managerId}/department/${params.departmentId}/abcrecharge`, params, userInfo.token, null)
  },
  issueCardSetting (userInfo, params) {
    return post(`/v1/company/manager/${userInfo.managerId}/position/${params.positionId}/issueCardSetting`, params, userInfo.token, null)
  },
  getSubscribers (userInfo) {
    return get(`/v3/manage/subscribers`, {
      companyId: userInfo.companyId,
      managerId: userInfo.managerId,
      type: 'email'
    }, userInfo.token)
  },
  addSubscribers (userInfo, param) {
    return post(`/v3/manage/subscribers`, param, userInfo.token, {
      companyId: userInfo.companyId,
      managerId: userInfo.managerId
    })
  },
  deleteSubscribers (userInfo, subscriberId) {
    return deleted(`/v3/manage/subscribers/${subscriberId}`, userInfo.token, {
      companyId: userInfo.companyId,
      managerId: userInfo.managerId
    })
  },
  queryAppliedSubsidies (userInfo, param) {
    return get(`/v3/manage/appliedSubsidies`, param, userInfo.token)
  },
  queryDelayUploadOrders (userInfo, param) {
    return get(`/v3/manage/delayUploadOrders`, param, userInfo.token)
  },
  dealDelayUploadOrders (userInfo, param) {
    return put(`/v3/manage/delayUploadOrders`, param, userInfo.token, {
      companyId: userInfo.companyId,
      managerId: userInfo.managerId
    })
  },
  setRechargeSettings (userInfo, param) {
    return post(`/v1/manage/companies/${userInfo.companyId}/recharge/settings`, param, userInfo.token, {
      managerId: userInfo.managerId
    })
  },
  updateImages (userInfo, param) {
    return post(`/v2/manage/company/${userInfo.companyId}/manager/${userInfo.managerId}/item/picture`, param, userInfo.token)
  },
  updateDishs (userInfo, hallId, param) {
    return post(`/v3/manage/hall/${hallId}/items?companyId=${userInfo.companyId}&managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  randomDiscounts (userInfo, param) {
    return get(`/v3/manage/companies/${userInfo.companyId}/orders/randomDiscounts/abstract`, param, userInfo.token)
  },
  hallRandomDiscountInfos (userInfo, param) {
    return get(`/v3/manage/hallRandomDiscountInfos`, param, userInfo.token)
  },
  deleteHallRandomDiscountInfos (userInfo, randomDiscountInfoId, param) {
    return deleted(`/v3/manage/hallRandomDiscountInfos/${randomDiscountInfoId}`, userInfo.token, param)
  },
  addHallRandomDiscountInfo (userInfo, param) {
    return post(`/v3/manage/hallRandomDiscountInfos?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  modifyHallRandomDiscountInfo (userInfo, param, randomDiscountInfoId) {
    return put(`/v3/manage/hallRandomDiscountInfos/${randomDiscountInfoId}?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  getDiningFileds (userInfo, param) {
    return get(`/v3/manage/companies/${userInfo.companyId}/diningFields`, param, userInfo.token)
  },
  deleteDiningFileds (userInfo, diningFieldId) {
    return deleted(`/v3/manage/companies/${userInfo.companyId}/diningFields?managerId=${userInfo.managerId}&diningFieldIds=${diningFieldId}`, userInfo.token)
  },
  addDiningFileds (userInfo, param) {
    return post(`/v3/manage/companies/${userInfo.companyId}/diningFields?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  modifyDiningFileds (userInfo, param) {
    return put(`/v3/manage/companies/${userInfo.companyId}/diningFields?managerId=${userInfo.managerId}`, param, userInfo.token)
  },
  getUserGroups (userInfo, param) {
    return get(`/v3/manage/userGroups`, param, userInfo.token)
  },
  addUserGroup (userInfo, param) {
    return post(`/v3/manage/userGroups?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  modifyUserGroup (userInfo, userGroupId, param) {
    return put(`/v3/manage/userGroups/${userGroupId}?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  getAutoPays (userInfo, param) {
    return get(`/v3/manage/userGroups/autoPays`, param, userInfo.token)
  },
  addAutoPays (userInfo, param) {
    return post(`/v3/manage/userGroups/autoPays?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  modifyAutoPays (userInfo, userGroupAutoPayId, param) {
    return put(`/v3/manage/userGroups/autoPays/${userGroupAutoPayId}?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  deleteAutoPay (userInfo, userGroupAutoPayId) {
    return deleted(`/v3/manage/userGroups/autoPays/${userGroupAutoPayId}?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, userInfo.token)
  },
  hallItemDiscountInfos (userInfo, param) {
    return get(`/v3/manage/hallItemDiscountInfos`, param, userInfo.token)
  },
  addHallItemDiscountInfo (userInfo, param) {
    return post(`/v3/manage/hallItemDiscountInfos`, param, userInfo.token, {
      companyId: userInfo.companyId,
      managerId: userInfo.managerId
    })
  },
  deleteHallItemDiscountInfo (userInfo, hallItemDiscountInfoId) {
    return deleted(`/v3/manage/hallItemDiscountInfos/${hallItemDiscountInfoId}?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, userInfo.token)
  },
  modifyHallItemDiscountInfo (userInfo, hallItemDiscountInfoId, param) {
    return put(`/v3/manage/hallItemDiscountInfos/${hallItemDiscountInfoId}?managerId=${userInfo.managerId}&companyId=${userInfo.companyId}`, param, userInfo.token)
  },
  withdrawals (userInfo, param) {
    return get(`/v3/admin/withdrawals`, param, userInfo.token)
  },
  lastSubsidySwapTime (userInfo, param) {
    return get(`/v3/manage/lastSubsidySwapTime`, param, userInfo.token)
  },
  planedSubsidySwapTime (userInfo, param) {
    return get(`/v3/manage/planedSubsidySwapTime`, param, userInfo.token)
  },
  planedSubsidySwapTimeMotify (userInfo, param) {
    return put(`/v3/manage/planedSubsidySwapTime`, param, userInfo.token, param)
  },
  triggerSubsidyTask (userInfo, param) {
    return get(`/v3/manage/triggerSubsidyTask`, param, userInfo.token)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js